const observeCartConfirmation = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.classList.contains('cart-confirmation__item')) {
        const salePriceElement = mutation.target.querySelector('.card__price--sale');
        const originalPriceElement = mutation.target.querySelector('.card__price--original');

        if (salePriceElement && originalPriceElement) {
          const originalPrice = parseFloat(originalPriceElement.textContent.replace('$', ''));
          const salePrice = parseFloat(salePriceElement.textContent.replace('$', ''));

          if (originalPrice >= salePrice) {
            salePriceElement.style.display = 'none';
          }
        }
      }
    });
  });

  const cartItems = document.querySelectorAll('.cart-confirmation__item');
  
  cartItems.forEach(item => {
    observer.observe(item, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true
    });
  });
};

document.addEventListener('DOMContentLoaded', observeCartConfirmation);